import { StakeToSpinResponseData } from "@lib/titan2-slingo/dist/api/data/StakeToSpinResponseData";
import { ExtendedGameUpdateData } from "../../data/ExtendedGameUpdateData";
/**
 * ExtendedStakeToSpinResponseData.ts
 */
export class ExtendedStakeToSpinResponseData extends StakeToSpinResponseData {
    solidifyGameUpdate() {
        if (this.dataExists(this.data)) {
            this.gameUpdate = new ExtendedGameUpdateData(this.data);
        }
    }
}
//# sourceMappingURL=ExtendedStakeToSpinResponseData.js.map